module.exports = __webpack_public_path__ + "static/media/mp4.ee43af90.svg";